module.exports = __webpack_public_path__ + "static/media/016-Rollstuhl_ID_1.6827a57a.mp3";